// extracted by mini-css-extract-plugin
export default {"main":"Referred_main__MvPPT","header":"Referred_header__CBTUd","btn":"Referred_btn__-f1oV","homepage":"Referred_homepage__j6WAK"};